import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layout/preloader/preloader.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { FunfactComponent } from './components/common/funfact/funfact.component';
import { FeedbackComponent } from './components/common/feedback/feedback.component';
import { SubscribeComponent } from './components/common/subscribe/subscribe.component';
import { AboutComponent } from './components/pages/about/about.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { BlogComponent } from './components/pages/blog/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { ServicesComponent } from './components/pages/services/services/services.component';
import { ServiceDetailsComponent } from './components/pages/services/service-details/service-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { WhyUsComponent } from './components/pages/why-us/why-us.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { InBoundComponent } from './components/pages/inBound/inBound.component';
import { BulkWhatsAppComponent } from './components/pages/bulk-whats-app/bulk-whats-app.component';
import { EducationComponent } from './components/pages/education/education.component';
import { HealthcareComponent } from './components/pages/healthcare/healthcare.component';
import { EcommerceComponent } from './components/pages/ecommerce/ecommerce.component';
import { RetailComponent } from './components/pages/retail/retail.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { HomeComponent } from './components/pages/home/home.component';
import { PlansComponent } from './components/pages/plans/plans.component';
// import { PromotionalCallsComponent } from './components/pages/promotional-calls/promotional-calls.component';
import { UtilitiesComponent } from './components/pages/utilities/utilities.component';
import { TourAndTravelsComponent } from './components/pages/tour-and-travels/tour-and-travels.component';
import { WhatsappComponent } from './components/pages/whatsapp/whatsapp.component';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BulkSmsSenderComponent } from './components/pages/bulk-sms-sender/bulk-sms-sender.component';
import { BookDemoComponent } from './components/pages/book-demo/book-demo.component';
import { TermsComponent } from './components/pages/terms/terms.component';
import { RefundPolicyComponent } from './components/pages/refund-policy/refund-policy.component';
import { PartnersPageComponent } from './components/pages/partners-page/partners-page.component';
import { HttpClientModule } from '@angular/common/http';
import { CookiesPolicyComponent } from './components/pages/cookies-policy/cookies-policy.component';
import { EmailComponent } from './components/pages/email/email.component';
import { WhatsappMetaComponent } from './components/pages/whatsapp-meta/whatsapp-meta.component';
import { RcsComponent } from './components/pages/rcs/rcs.component';
import { IvrComponent } from './components/pages/ivr/ivr.component';
import { RouterModule } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
 
 

  

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    HomeOneComponent,
    HomeTwoComponent,
    HomeThreeComponent,
    HomeFourComponent,
    FunfactComponent,
    FeedbackComponent,
    SubscribeComponent,
    AboutComponent,
    FeaturesComponent,
    TeamComponent,
    BlogComponent,
    BlogDetailsComponent,
    ServicesComponent,
    ServiceDetailsComponent,
    ContactComponent,
    FaqComponent,
    ComingSoonComponent,
    NotFoundComponent,
    PricingComponent,
    LoginComponent,
    RegisterComponent,
    WhyUsComponent,
    AboutUsComponent,
    CareersComponent,
    InBoundComponent,
    BulkWhatsAppComponent,
    // PromotionalCallsComponent,
    EducationComponent,
    HealthcareComponent,
    EcommerceComponent,
    RetailComponent,
    PrivacyComponent,
    PlansComponent,
    UtilitiesComponent,
    TourAndTravelsComponent,
    WhatsappComponent,
    BulkSmsSenderComponent,
    BookDemoComponent,
    TermsComponent,
    RefundPolicyComponent,
    PartnersPageComponent,
    CookiesPolicyComponent,
    EmailComponent,
    WhatsappMetaComponent,
    RcsComponent,
    IvrComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    RouterModule,
    FormsModule, 
    ReactiveFormsModule,
    RecaptchaModule,
     
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [Location, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }